import gsap from 'gsap'

export default class CardShuffler {

  constructor(selector) {
    this.selector = selector
    this.cardContents = document.querySelectorAll(this.selector)
    this.init()
  }

  /**
   * init card shuffler
   */
  init() {
    this.cardContents.forEach(cardContent => this.setupCardContent(cardContent))
  }

  /**
   * 
   * @param {HTMLElement} cardContent 
   */

  setupCardContent(cardContent) {
    const cardBlocks = cardContent.querySelectorAll('.card-block')
    const totalCards = cardBlocks.length
    const rotateChunk = Math.ceil(totalCards / 3)
    let zIndex = totalCards

    cardBlocks.forEach((cardBlock, index) => {
      this.setupCardBlock(cardBlock, index, zIndex--)
    })

    this.animateFirstCard(cardBlocks[0], cardBlocks, 0) // 最初のカードでアニメーションを開始
    this.rotateCards(cardBlocks, rotateChunk)
  }

  /**
   * 
   * @param {*} cardBlock 
   * @param {*} index 
   * @param {*} zIndex 
   */
  setupCardBlock(cardBlock, index, zIndex) {
    cardBlock.setAttribute('data-order', index + 1)
    cardBlock.style.zIndex = zIndex
  }

  animateFirstCard(cardBlock, cardBlocks, index) {
    cardBlock.classList.add('-current')
    gsap.to(cardBlock, {
      delay: 2.5,
      onComplete: () => {
        cardBlock.classList.add('-go')
        gsap.to(cardBlock, {
          onStart: () => {
            cardBlock.classList.remove('-go')
            cardBlock.classList.add('-back')
            cardBlock.style.zIndex = 0 // zIndexを更新して最背面に移動
          },
          delay: 1,
          onComplete: () => {
            cardBlock.classList.remove('-current', '-back')
            cardBlocks.forEach((cb) => {
              let currentZIndex = parseInt(cb.style.zIndex, 10)
              cb.style.zIndex = currentZIndex + 1
            })
            const nextIndex = (index + 1) % cardBlocks.length // 次のカードのインデックスを計算し、必要に応じて0にリセット
            this.animateFirstCard(cardBlocks[nextIndex], cardBlocks, nextIndex) // 次のカードでアニメーションを再開
          }
        })
      }
    })
  }

  /**
   * 
   * @param {*} cardBlocks 
   * @param {*} rotateChunk
   */
  rotateCards(cardBlocks, rotateChunk) {
    for (let i = 0; i < rotateChunk; i++) {
      for (let j = 0; j < 3; j++) {
        const rotate = (5 * j) - 2
        const cardIndex = j + (i * 3) + 1
        cardBlocks.forEach(cardBlock => {
          if (cardBlock.dataset.order == cardIndex) {
            cardBlock.style.transform = `rotate(${rotate}deg)`
          }
        })
      }
    }
  }
}